import { getBrowser } from './browser';
import { uuidv4 } from 'lib0/random.js';
import store from '../store/index';

export function setSaviorConfigure(configure) {
    if (window.setBaseData) {
        console.log(
            'saviorEventUUIDsaviorEventUUIDsaviorEventUUIDsaviorEventUUID',
            saviorEventUUID
        );
        window.setBaseData({
            auto: false,
            company: '3',
            productid: '198',
            platid: '10138',
            expandfield: {
                ...(configure?.expandfield ?? {}),
                saviorEventUUID
            }
        });
    } else {
        setTimeout(setSaviorConfigure, 500);
    }
}

export const saviorEventUUID = uuidv4();

export function updateSaviorData(data) {
    const map = {
        base: {
            rootpaltid: getRootpaltid(),
            appversion: getAppVersion()
        },
        page: {
            eventtype: data.eventtype,
            category: data.category,
            action: data.eventtype,
            label: data.label,
            pageurl: window.location.href.toString(),
            eventid: data.eventid,
            value: JSON.stringify(data.value || {})
        },
        user: {
            memberid: getInfo('userId'),
            thistime: `${Date.now()}`,
            tc_deviceid: getInfo('deviceId'),
            el_deviceid: getInfo('deviceId')
        },
        device: {
            env: 'webview=h5'
        },
        saviorExtension: data.saviorExtension || {}
    };
    window?.setSaviorData(map);
}

function getRootpaltid() {
    let isMobile = getBrowser().isMobile;
    let isInToca = getBrowser().isInTocaApp;
    if (isInToca === true) {
        if (isMobile === true) {
            return '2'; //移动端
        } else {
            return '0'; //pc
        }
    } else {
        return '1'; //web
    }
}

function getInfo(key) {
    // console.log('store.state.currentUserInfo', store.state.currentUserInfo)
    return store.state.currentUserInfo[key];
}

function getAppVersion() {
    const ua = window.navigator.userAgent || '';
    const matchs = ua.match(/(toca|tiexin)\/([\d\.]+)/i);
    return matchs ? matchs[2] : '';
}